/**
 * Kullancu0131nu0131n cou011frafi konumunu tespit etmek iu00e7in yardu0131mcu0131 fonksiyonlar
 */

/**
 * Kullancu0131nu0131n IP adresi u00fczerinden u00fclke kodunu tespit eder
 * @returns {Promise<string|null>} u00dclke kodu (ISO 3166-1 alpha-2 formatu0131nda) veya null
 */
export const getUserCountryCode = async () => {
  try {
    // Yerel depolamada kaydedilmiu015f u00fclke kodu var mu0131 kontrol et
    const cachedCountry = localStorage.getItem('user_country_code');
    const cachedTimestamp = localStorage.getItem('user_country_code_timestamp');
    
    // u00d6nbellek geu00e7erli mi kontrol et (24 saat)
    if (cachedCountry && cachedTimestamp) {
      const now = Date.now();
      const cacheAge = now - parseInt(cachedTimestamp, 10);
      const oneDayInMs = 24 * 60 * 60 * 1000;
      
      if (cacheAge < oneDayInMs) {
        return cachedCountry;
      }
    }
    
    // IP bazlu0131 u00fclke tespiti yapan u00fccretsiz bir API kullan
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    if (data && data.country) {
      // Sonucu u00f6nbellek olarak kaydet (24 saat geu00e7erli)
      localStorage.setItem('user_country_code', data.country);
      localStorage.setItem('user_country_code_timestamp', Date.now());
      return data.country;
    }
    
    return null;
  } catch (error) {
    console.error('u00dclke tespiti yaplu0131lamadu0131:', error);
    return null;
  }
};

/**
 * Kullancu0131nu0131n Avrupa Birliu011fi u00fcyesi bir u00fclkede olup olmadu0131u011fu0131nu0131 kontrol eder
 * @param {string} countryCode - u00dclke kodu (ISO 3166-1 alpha-2 formatu0131nda)
 * @returns {boolean} Avrupa Birliu011fi u00fcyesi ise true, deu011filse false
 */
export const isEuropeanUnion = (countryCode) => {
  if (!countryCode) return false;
  
  // AB u00fcyesi u00fclkelerin ISO kodlaru0131
  const euCountries = [
    'AT', // Avusturya
    'BE', // Belu00e7ika
    'BG', // Bulgaristan
    'HR', // Hu0131rvatistan
    'CY', // Ku0131bru0131s
    'CZ', // u00c7ekya
    'DK', // Danimarka
    'EE', // Estonya
    'FI', // Finlandiya
    'FR', // Fransa
    'DE', // Almanya
    'GR', // Yunanistan
    'HU', // Macaristan
    'IE', // u0130rlanda
    'IT', // u0130talya
    'LV', // Letonya
    'LT', // Litvanya
    'LU', // Lu00fcksemburg
    'MT', // Malta
    'NL', // Hollanda
    'PL', // Polonya
    'PT', // Portekiz
    'RO', // Romanya
    'SK', // Slovakya
    'SI', // Slovenya
    'ES', // u0130spanya
    'SE', // u0130sveu00e7
    'GB', // Birleu015fik Krallu0131k (Brexit sonrasu0131 AB'den ayrlu0131lmu0131u015f olsa da GDPR'a uyum sau011flama zorunluluu011fu var)
    'NO', // Norveu00e7 (AB u00fcyesi deu011fil ama GDPR'a uyum sau011flama zorunluluu011fu var)
    'IS', // u0130zlanda (AB u00fcyesi deu011fil ama GDPR'a uyum sau011flama zorunluluu011fu var)
    'LI', // Lihtenu015ftayn (AB u00fcyesi deu011fil ama GDPR'a uyum sau011flama zorunluluu011fu var)
    'CH'  // u0130sviu00e7re (AB u00fcyesi deu011fil ama GDPR'a uyum sau011flama zorunluluu011fu var)
  ];
  
  return euCountries.includes(countryCode.toUpperCase());
};

/**
 * Kullancu0131nu0131n Tu00fcrkiye'de olup olmadu0131u011fu0131nu0131 kontrol eder
 * @param {string} countryCode - u00dclke kodu (ISO 3166-1 alpha-2 formatu0131nda)
 * @returns {boolean} Tu00fcrkiye'de ise true, deu011filse false
 */
export const isTurkey = (countryCode) => {
  return countryCode === 'TR';
};

/**
 * Kullancu0131nu0131n u00e7erez bildirimi gu00f6ru00fcntulenmesi gereken bir bu00f6lgede olup olmadu0131u011fu0131nu0131 kontrol eder
 * @returns {Promise<boolean>} u00c7erez bildirimi gu00f6ru00fcntulenmesi gerekiyorsa true, gerekmiyorsa false
 */
export const shouldShowCookieConsent = async () => {
  try {
    const countryCode = await getUserCountryCode();
    
    // Tu00fcrkiye veya AB u00fcyesi u00fclkeler iu00e7in u00e7erez bildirimi gu00f6ster
    if (isTurkey(countryCode) || isEuropeanUnion(countryCode)) {
      return true;
    }
    
    // Geu00e7ersiz u00fclke kodu durumunda, gu00fcvenli tarafta kal ve bildirimi gu00f6ster
    if (!countryCode) {
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('u00c7erez bildirimi kontrolu00fc yaplu0131lamadu0131:', error);
    // Hata durumunda, gu00fcvenli tarafta kal ve bildirimi gu00f6ster
    return true;
  }
};
